import ConfigAPI from 'remote/config'
import { getApiEndpoint } from 'data/config/selectors'
import { getApiToken } from 'data/auth/selectors'

import { FETCH_VERSION, FETCH_SEARCH_TOKEN } from './actionTypes'

export function fetchVersion() {
  return {
    type: FETCH_VERSION,
    payload: ConfigAPI.fetchVersion(),
  }
}

export const fetchSearchToken = () => ({ getState }) => {
  const state = getState()
  const apiEndpoint = getApiEndpoint(state)
  const apiToken = getApiToken(state)
  return {
    type: FETCH_SEARCH_TOKEN,
    payload: {
      promise: ConfigAPI.fetchSearchToken({ apiEndpoint, apiToken }),
    },
  }
}
